<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-28 11:06:55
 * @LastEditors: shayne
 * @LastEditTime: 2022-09-29 14:55:46
 * @FilePath: /privacy-web/src/views/PrivacyProtect/index.vue
-->
<template>
  <div class="privacy-protect">
    <!-- 科技 守护 start -->
    <Science-integrity></Science-integrity>
    <!-- 科技 守护 end -->
    <!--  贝壳隐私保护理念 start -->
    <Privacy-protect-concept :src="dataList"></Privacy-protect-concept>
    <!--  贝壳隐私保护理念 end -->
    <!-- 管理体系 start -->
    <Manage-system></Manage-system>
    <!-- 管理体系 end -->
    <!-- 管理流程 start -->
    <Manage-process></Manage-process>
    <!-- 管理流程 end -->
    <!-- 隐私 保护 start -->
    <!-- <Security-type></Security-type> -->
    <!-- 隐私 保护 end -->
    <!-- 权威认证 start -->
    <AuthoritativeCertification></AuthoritativeCertification>
    <!-- 权威认证 end -->
  </div>
</template>

<script>
import ManageSystem from "./ManageSystem.vue";
import ManageProcess from "./ManageProcess.vue";
// import SecurityType from './SecurityType.vue';
import ScienceIntegrity from "./ScienceIntegrity.vue";
import AuthoritativeCertification from "./AuthoritativeCertification.vue";
import PrivacyProtectConcept from "../PrivacyProtect/PrivacyProtectConcept.vue";
export default {
  // 隐私保护入口
  name: "privacyProtect-index",
  components: {
    ManageSystem,
    ManageProcess,
    // SecurityType,
    ScienceIntegrity,
    AuthoritativeCertification,
    PrivacyProtectConcept,
  },
  data() {
    return {
      dataList: {
        video: "",
        poster: "",
      },
    };
  },
  async created() {
    this.readDictByKey("video", (res) => {
      this.dataList.video =
        (isMobile
          ? res.list.map.algorithmTransparent.videoMobile
          : res.list.map.algorithmTransparent.video) ||
        "https://devlawtrust-1306822285.cos.ap-beijing.myqcloud.com/video/beike_privacy.mp4";
      this.dataList.poster =
        res.list.map.algorithmTransparent.thumbnail ||
        "https://devlawtrust-1306822285.cos.ap-beijing.myqcloud.com/resource-config/thumbnail.png";
    });
  },
};
</script>
